module.exports = __webpack_public_path__ + "static/media/turnOff.687ec589.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/turnOff.png
// module id = 767
// module chunks = 0